(function () {
  if (customElements.get('cart-notification')) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  var SECTIONS = 'merina-cart,cart-icon-bubble';
  var TIMER_KEY = 'mcTimerEnd';
  var TIMER_MS = 15 * 60 * 1000;
  var parser = new DOMParser();
  function isCartUrl(u) {
    u = String(u || '');
    return u.indexOf('/cart/add') > -1 || u.indexOf('/cart/change') > -1 || u.indexOf('/cart/update') > -1 || u.indexOf('/cart/clear') > -1;
  }

  class MerinaCart extends HTMLElement {
    connectedCallback() {
      if (this.parentElement !== document.body) { document.body.appendChild(this); return; }
      if (this._ready) return;
      this._ready = true;
      this._lastRender = 0;
      this._openedAt = 0;
      this._pending = 0;
      this._queue = Promise.resolve();
      this._timer = null;
      var self = this;

      this.addEventListener('click', function (e) {
        if (e.target.closest('[data-mc-close]')) { e.preventDefault(); self.close(); return; }
        var b = e.target.closest('[data-mc-qty]');
        if (b) { e.preventDefault(); self.onQty(b); }
      });

      // Cierre al tocar fuera del carrito (móvil y escritorio)
      var overlay = this.querySelector('.mc__overlay');
      function outside(e) {
        if (!self.classList.contains('is-open')) return;
        if (Date.now() - self._openedAt < 350) return;
        var panel = self.querySelector('.mc__panel');
        if (panel && panel.contains(e.target)) return;
        if (e.cancelable) e.preventDefault();
        self.close();
      }
      if (overlay) {
        overlay.addEventListener('touchend', outside, { passive: false });
        overlay.addEventListener('pointerup', outside);
      }

      this.addEventListener('submit', function (e) {
        if (self._pending > 0) {
          e.preventDefault();
          self._queue.then(function () { window.location.href = root + 'checkout'; });
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.classList.contains('is-open')) self.close();
      });

      document.addEventListener('click', function (e) {
        var t = e.target.closest('#cart-icon-bubble, a[href="/cart"], a[href="' + root + 'cart"]');
        if (!t || self.contains(t)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        self.open();
      }, true);

      this.patchNetwork();
    }

    getSectionsToRender() { return [{ id: 'merina-cart' }, { id: 'cart-icon-bubble' }]; }
    setActiveElement(el) { this._active = el; }

    renderContents(r) {
      this._lastRender = Date.now();
      if (r && r.sections && r.sections['merina-cart']) { this.apply(r.sections); } else { this.refresh(); }
      this.open();
    }

    apply(sections) {
      if (sections['merina-cart']) {
        var inner = parser.parseFromString(sections['merina-cart'], 'text/html').querySelector('.mc__inner');
        var target = this.querySelector('.mc__inner');
        if (inner && target) target.innerHTML = inner.innerHTML;
      }
      if (sections['cart-icon-bubble']) {
        var src = parser.parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        var dst = document.getElementById('cart-icon-bubble');
        if (src && dst) dst.innerHTML = src.innerHTML;
      }
      this.classList.toggle('is-empty', !this.querySelector('.mc__item'));
      this.tick();
    }

    refresh() {
      var self = this;
      return nativeFetch(root + '?sections=' + SECTIONS)
        .then(function (r) { return r.json(); })
        .then(function (s) { self.apply(s); })
        .catch(function (e) { console.error(e); });
    }

    onQty(btn) {
      var li = btn.closest('[data-key]');
      if (!li) return;
      var span = li.querySelector('.mc__qty span');
      var current = parseInt(span ? span.textContent : '0', 10) || 0;
      var next;
      if (btn.classList.contains('mc__remove')) {
        next = 0;
      } else {
        var minus = li.querySelector('.mc__qty [data-mc-qty]');
        var serverQty = (parseInt(minus.dataset.mcQty, 10) || 0) + 1;
        next = current + (parseInt(btn.dataset.mcQty, 10) - serverQty);
      }
      next = Math.max(0, next);
      if (span) span.textContent = next;
      if (next === 0) li.style.display = 'none';
      this.change(li.dataset.key, next);
    }

    change(key, qty) {
      var self = this;
      this._pending++;
      this._queue = this._queue.then(function () {
        return nativeFetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty, sections: SECTIONS, sections_url: location.pathname })
        })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            self._pending--;
            if (self._pending > 0) return;
            if (d && d.sections) { self.apply(d.sections); } else { return self.refresh(); }
          })
          .catch(function (e) {
            self._pending--;
            console.error(e);
            if (self._pending === 0) return self.refresh();
          });
      });
      return this._queue;
    }

    external(url) {
      var self = this;
      var isAdd = String(url).indexOf('/cart/add') > -1;
      setTimeout(function () {
        if (Date.now() - self._lastRender < 2000) return;
        self.refresh().then(function () { if (isAdd) self.open(); });
      }, 400);
    }

    patchNetwork() {
      var self = this;
      window.fetch = function (input, init) {
        var url = input && input.url ? input.url : String(input || '');
        var p = nativeFetch(input, init);
        if (isCartUrl(url)) p.then(function (r) { if (r.ok) self.external(url); }).catch(function () {});
        return p;
      };
      var xo = XMLHttpRequest.prototype.open;
      var xs = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (m, u) { this._mcUrl = String(u || ''); return xo.apply(this, arguments); };
      XMLHttpRequest.prototype.send = function () {
        var x = this;
        if (isCartUrl(x._mcUrl)) x.addEventListener('load', function () { if (x.status < 400) self.external(x._mcUrl); });
        return xs.apply(this, arguments);
      };
    }

    tick() {
      var now = Date.now();
      var end = 0;
      try { end = parseInt(sessionStorage.getItem(TIMER_KEY) || '0', 10); } catch (e) {}
      if (!end || end <= now) {
        end = now + TIMER_MS;
        try { sessionStorage.setItem(TIMER_KEY, String(end)); } catch (e) {}
      }
      var left = Math.max(0, Math.round((end - now) / 1000));
      var m = Math.floor(left / 60);
      var s = left % 60;
      var txt = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
      var els = this.querySelectorAll('[data-mc-timer]');
      for (var i = 0; i < els.length; i++) els[i].textContent = txt;
    }

    open() {
      var self = this;
      this._openedAt = Date.now();
      this.tick();
      if (!this._timer) this._timer = setInterval(function () { self.tick(); }, 1000);
      this.classList.add('is-open');
      this.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');
      var p = this.querySelector('.mc__panel');
      if (p) setTimeout(function () { p.focus({ preventScroll: true }); }, 50);
    }

    close() {
      if (this._timer) { clearInterval(this._timer); this._timer = null; }
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');
      if (this._active && this._active.focus) this._active.focus({ preventScroll: true });
    }
  }

  customElements.define('cart-notification', MerinaCart);
})();
